<template>
  <tr>
    <td>

      <img :src="DBitems.product.image" :alt="DBitems.product.name" class="cart_img">


    </td>
    <td>
      <router-link :to="{
        name: 'product',
        params: { storeName: $store.storeName, id: this.item.product_id, name: this.DBitems.product.name, lang: $i18n.locale },
      }" style="font-size: 13px; color: rgb(0 38 62 / 70%) !important;"> 
      {{ DBitems.product.name.substring(0,15) }}</router-link>
    </td>
    <strong  v-if="item.jellwery">
            {{calculateItemPrice(item.jellwery)}} 
          </strong>
    <td v-else-if="item.offer_price != 0">{{ ((item.offer_price/item.quantity) * $store.state.rate).toFixed($store.state.digit_price) }}
      {{ $store.state.UnitPrice }}</td>
    <td v-else>

      {{ ((item.total_price/item.quantity) * $store.state.rate).toFixed($store.state.digit_price) }} {{ $store.state.UnitPrice }}
    </td>


    <td>
      <div class="input-group input-group-sm">
        <button class="btn btn-outline-secondary " type="button" @click="decrementClick()">−</button>
        <input id="quantityInput" type="text" class="form-control text-center" v-model="item.quantity" style="max-width: 40px;" readonly>
        <button class="btn btn-outline-secondary plus" type="button" @click="incrementClick()">+</button>
      </div>

    </td>

   <td v-if="item.offer_price != 0">{{ ((item.offer_price) * $store.state.rate).toFixed($store.state.digit_price) }}
      {{ $store.state.UnitPrice }}</td>
    <td v-else>

      {{ ((item.total_price) * $store.state.rate).toFixed($store.state.digit_price) }} {{ $store.state.UnitPrice }}
    </td>

    <td><button @click="show = true" class="truch_icon
                        "><i class="fa fa-trash-o" style="font-size: 16px;"></i></button></td>
                        <Transition name="modal">
    <div v-if="show" class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container">
          <div class="modal-header">
            <slot name="header">{{ $t('confirmdelete') }}</slot>
          </div>
          <div class="modal-footer">
            <slot name="footer">
              <button class="modal-default-button" @click="deleteItem()">{{ $t('confirm') }}</button>
              <button class="modal-default-button" @click="(show = false), $emit('close')">{{ $t('cancel') }}</button>
            </slot>
          </div>
        </div>
      </div>
    </div>
  </Transition>
  </tr>
 
</template>

<script>
export default {
  props: {
    itemId: String
  },
  data: function () {
    return {
      loading: false,
      DBitems: null,
      item: null,
      show: false
    };
  },
  created() {
    this.loading = true;
    this.item = this.$cookies.get(this.itemId);
    if (this.item != null) {
      //console.log(this.item)
      this.axios
        .post(
          this.$store.state.base_api_url + this.$store.storeName + "/cart_item",
          {
            product_id: this.item.product_id,
            final_option: this.item.final_option,
            option_check: this.item.option_check
          },
          {
            headers: {
              "Accept-Language": this.$i18n.locale
            }
          }
        )
        .then(response => {
          this.DBitems = response.data.data;
          /*if (this.sections.size > 7) {
          if (document.documentElement.getAttribute("dir") === "rtl") {
            this.sections = this.sections.slice().reverse();
          }
        }*/
        })
        .then(() => (this.loading = false));
    }
  },
  methods: {
    incrementClick() {
      // ++this.counterVal;
      console.log(
        "incrementtt" + this.item.quantity + " " + this.item.quantityAll
      );



      //////////////////////////////////////////////////////////
      let S_name_full =
        this.$store.storeName +
        "/" +
        this.item.product_id +
        this.item.final_option +
        this.item.option_check;

      let S_name =
        this.$store.storeName +
        "/" +
        this.item.product_id +
        this.item.final_option;
      console.log("S_name " + S_name);

      let qun = this.item.quantityAll;
      console.log('qun****************', qun)
      let min_qun = this.item.min_quantity;


      let max_qun = this.item.max_quantity;
      console.log("this.item.quantityAll" + this.item.quantityAll);

      let AllCookies = this.$cookies.keys();
      for (let i = 0; i < AllCookies.length; i++) {
        if (AllCookies[i].includes(S_name)) {
          if (AllCookies[i] == S_name_full) {
            console.log("hii i am there ");
          } else {
            qun = qun - this.$cookies.get(AllCookies[i]).quantity;
            min_qun = this.$cookies.get(AllCookies[i]).min_quantity;
            max_qun = this.$cookies.get(AllCookies[i]).max_quantity;
            console.log(
              this.$cookies.get(AllCookies[i]).quantity + " quuuuun " + qun
            );

            console.log(
              this.$cookies.get(AllCookies[i]).min_quantity + " min quuuuun " + min_qun
            );
          }
        }
      }
      //////////////////////////////////////////////////////////
      if (this.item.quantityAll > 0) {
        if (this.item.quantity < qun
          && this.item.quantity < max_qun
          // && this.item.quantity > min_qun
        ) {
          ++this.item.quantity;
          this.item.total_price =
            this.item.total_price / (this.item.quantity - 1) +
            this.item.total_price;
          /*if (this.item.offer_price != 0) {
          this.item.offer_price =
            this.item.total_price -
            (this.item.discount / 100) * this.item.total_price;
        }*/
          if (this.item.offer_price != 0) {
            this.item.offer_price =
              this.item.offer_price / (this.item.quantity - 1) +
              this.item.offer_price;
          }

          //////////update this key
          let product = {
            product_id: this.item.product_id,
            total_price: this.item.total_price,
            offer_price: this.item.offer_price,
            quantity: this.item.quantity,
            quantityAll: this.item.quantityAll,
            min_quantity: this.item.min_quantity,
            max_quantity: this.item.max_quantity,
            final_option: this.item.final_option,
            option_check: this.item.option_check,
            discount: this.item.discount,
            note: this.item.note
          };
          this.$cookies.set(this.itemId, product);
          this.$parent.updateProducts();
        }
      } else {
        ++this.item.quantity;
        this.item.total_price =
          this.item.total_price / (this.item.quantity - 1) +
          this.item.total_price;
        /* if (this.item.offer_price != 0) {
          this.item.offer_price =
            this.item.total_price -
            (this.item.discount / 100) * this.item.total_price;
        }*/
        if (this.item.offer_price != 0) {
          this.item.offer_price =
            this.item.offer_price / (this.item.quantity - 1) +
            this.item.offer_price;
        }

        //////////update this key
        let product = {
          product_id: this.item.product_id,
          total_price: this.item.total_price,
          offer_price: this.item.offer_price,
          quantity: this.item.quantity,
          quantityAll: this.item.quantityAll,
          final_option: this.item.final_option,
          option_check: this.item.option_check,
          discount: this.item.discount,
          note: this.item.note
        };
        this.$cookies.set(this.itemId, product);
        this.$parent.updateProducts();
      }
    },
    decrementClick() {
      let min_qun = this.item.min_quantity;


      let max_qun = this.item.max_quantity;
      console.log(
        "decrementttt" + this.item.quantity + " ", this.item
      );
      if (this.item.quantity > 1
        && (this.item.quantity > min_qun ||(min_qun==null))
      ) {
        //  --this.counterVal;
        --this.item.quantity;
        //this.price = this.price/2
        this.item.total_price =
          this.item.total_price -
          this.item.total_price / (this.item.quantity + 1);
        /*if (this.item.offer_price != 0) {
          this.item.offer_price =
            this.item.total_price -
            (this.item.discount / 100) * this.item.total_price;
        }*/
        if (this.item.offer_price != 0) {
          this.item.offer_price =
            this.item.offer_price -
            this.item.offer_price / (this.item.quantity + 1);
        }

        //////////update this key
        let product = {
          product_id: this.item.product_id,
          total_price: this.item.total_price,
          offer_price: this.item.offer_price,
          quantity: this.item.quantity,
          quantityAll: this.item.quantityAll,
          min_quantity: this.item.min_quantity,
          max_quantity: this.item.max_quantity,
          final_option: this.item.final_option,
          option_check: this.item.option_check,
          discount: this.item.discount,
          note: this.item.note
        };
        this.$cookies.set(this.itemId, product);
        this.$parent.updateProducts();
      }
    },
    deleteItem() {
      //this.loading = true;
      this.$cookies.remove(this.itemId);
      console.log("remove" + this.$cookies.keys());
      if(this.$store.state.cartCounter>0)
      this.$store.state.cartCounter = this.$store.state.cartCounter - 1;
      this.$destroy();
      this.$parent.updateProducts();
      this.$el.parentNode.removeChild(this.$el);
    },
      calculateItemPrice(item) {
      console.log("2025-11-09");
      let basePrice = item.type === "gold" ? this.$store.state.gold.qar_ask :
        this.$store.state.silver.qar_ask; // السعر على أساس عيار 24
      let purityFactor = item.purity / 24;
      let manufacturing = Number(item.gold_manufacturing || 0);
      let countGram = Number(item.count_gram || 1);

      return ((((basePrice * purityFactor) + manufacturing) * countGram).toFixed(2)) * this.item.quantity;
    },
  }
};
</script>